import { createReducer, Action, on } from '@ngrx/store';

import { ChecklistListActions } from './checklist-list.actions';
import { ChecklistListState } from './checklist-list.state';
import { MY_TOPICS_ID } from '../../features/checklist/constants/my-topics-id';
import { replaceInArrayByProperty } from '../../features/shared/utils/replace-in-array-by-property';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { AppActions } from '../app/app.actions';
import { ChecklistActions } from '../checklist/checklist.actions';

export const initialState: ChecklistListState = {
  loading: false,
  selectedChecklistId: MY_TOPICS_ID,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      ChecklistListActions.LoadList,
      (state): ChecklistListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      ChecklistListActions.LoadListSuccess,
      (state, action): ChecklistListState => ({ ...state, loading: false, list: action.list })
    ),
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): ChecklistListState => ({
        ...state,
        selectedChecklistId:
          action.data?.assetSettings?.selectedChecklistId || state.selectedChecklistId,
      })
    ),
    on(
      ChecklistListActions.Delete,
      (state): ChecklistListState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      ChecklistListActions.DeleteSuccess,
      (state, action): ChecklistListState => ({
        ...state,
        loading: false,
        selectedChecklistId:
          state.selectedChecklistId === action.checklist?.id
            ? MY_TOPICS_ID
            : state.selectedChecklistId,
        list: state.list?.filter((i) => i.id !== action.checklist?.id),
      })
    ),
    on(
      ChecklistListActions.LoadListFail,
      ChecklistListActions.DeleteFail,
      (state, action): ChecklistListState => ({ ...state, loading: false, error: action.error })
    ),
    on(
      ChecklistListActions.Search,
      (state, action): ChecklistListState => ({ ...state, search: action.search })
    ),
    on(
      ChecklistListActions.Sort,
      (state, action): ChecklistListState => ({ ...state, sort: action.sort })
    ),
    on(
      ChecklistListActions.Filter,
      (state, action): ChecklistListState => ({ ...state, filter: action.filter })
    ),
    on(
      ChecklistListActions.SelectChecklist,
      (state, action): ChecklistListState => ({ ...state, selectedChecklistId: action.id })
    ),
    on(
      ChecklistActions.SaveModelSuccess,
      (state, action): ChecklistListState => ({
        ...state,
        list: replaceInArrayByProperty(state.list, 'id', action.checklist),
      })
    )
  )
);

export function reducer(state: ChecklistListState | undefined, action: Action) {
  return featureReducer(state, action);
}
